<template>
  <div class="payment-selection-container">
    <div class="header-actions">
      <el-button round icon="el-icon-back" @click="$emit('back', 'frequency')">返回</el-button>
    </div>

    <div class="content-wrapper">
      <div class="total-amount">
        訂單總計 <span class="highlight">NT$ {{ safeInfo.total }}</span>
      </div>

      <el-row :gutter="20" type="flex" justify="center" class="m-b-20">
        <el-col :xs="24" :sm="10" :md="8">
          <div class="payment-card" @click="$emit('next', { key: 'method', value: 'offline' })">
            <div class="icon-circle">
              <BaseIcon name="money-bill-wave-alt" icon-style="fal" />
            </div>
            <h3 class="card-title">線下付款</h3>
            <p class="card-desc">現場信用卡、線下匯款、現金付款</p>
          </div>
        </el-col>

        <el-col v-if="safeInfo.paymentMethods.includes('Credit') || safeInfo.paymentMethods.includes('Vacc')" :xs="24" :sm="10" :md="8">
          <div class="payment-card" @click="$emit('next', { key: 'method', value: 'online' })">
            <div class="icon-circle">
              <BaseIcon name="credit-card-alt" icon-style="fat" />
            </div>
            <h3 class="card-title">線上付款</h3>
            <p class="card-desc">線上信用卡、虛擬帳戶</p>
          </div>
        </el-col>
      </el-row>
      <el-row v-if="safeInfo.paymentMethods.includes('Deposit')" type="flex" justify="center">
        <el-col :xs="24" :sm="10" :md="8">
          <div class="payment-card" @click="$emit('fetchPayMethod', 'Deposit')">
            <div class="icon-circle">
              <BaseIcon name="usd-circle" icon-style="fal" />
            </div>
            <h3 class="card-title">儲值點數抵扣</h3>
            <p class="card-desc"
              >點數餘額：<span class="highlight-text">{{ safeInfo.deposit.total }}點</span></p
            >
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Step2Method',
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({ total: 0, paymentMethods: [], deposit: { total: 0 } }),
    },
  },
  computed: {
    safeInfo() {
      const p = this.paymentInfo || {}
      return {
        total: p.total || 0,
        paymentMethods: Array.isArray(p.paymentMethods) ? p.paymentMethods : [],
        deposit: p.deposit || { total: 0 },
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.payment-selection-container {
  padding: 20px;
  background-color: #fcfcfc;
  min-height: 100vh;

  .header-actions {
    margin-bottom: 20px;
  }

  .content-wrapper {
    text-align: center;
    max-width: 900px;
    margin: 0 auto;

    .total-amount {
      font-size: 1.2rem;
      margin-bottom: 40px;
      color: #606266;
      .highlight {
        color: #ea6a2a;
        font-weight: bold;
        margin-left: 10px;
      }
    }
  }

  .m-b-20 {
    margin-bottom: 20px;
  }

  .payment-card {
    background: #fff;
    border: 1px solid #ebeef5;
    border-radius: 12px;
    padding: 40px 20px;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;

    &:hover:not(.disabled) {
      transform: translateY(-5px);
      box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
      border-color: #ea6a2a;
    }

    &.disabled {
      cursor: not-allowed;
      opacity: 0.7;
      background-color: #fafafa;
    }

    .icon-circle {
      width: 100px;
      height: 100px;
      border: 2px solid #ea6a2a;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      color: #ea6a2a;
      margin-bottom: 20px;
    }

    .card-title {
      font-size: 1.1rem;
      color: #303133;
      margin: 0 0 10px 0;
    }

    .card-desc {
      font-size: 0.9rem;
      color: #909399;
      margin: 0;

      .highlight-text {
        color: #ea6a2a;
      }
    }
  }
}
</style>
